// extracted by mini-css-extract-plugin
export default {"app":"qdbE75lC3a0rIxNs_yI8","button":"iotES90LmqZXdCJwFM9B"};